.root {
  display: flex;
  gap: 0.5rem;
  padding-top: 0.5rem;
  font-size: var(--font-size-body-2);
}
